
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/learn/[url]",
      function () {
        return require("private-next-pages/learn/[url].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/learn/[url]"])
      });
    }
  